/**
 * Default icon set
 * Naming is important!
 */

import accountIcon from './ico-account.svg';
import disclosureArrowIcon from './ico-arrow-disclosure.svg';
import leftArrowIcon from './ico-arrow-left.svg';
import rightArrowIcon from './ico-arrow-right.svg';
import bottomArrowSmallIcon from './ico-arrow-down-small.svg';
import rightArrowIconSmall from './ico-arrow-right-small.svg';
import downArrowIcon from './ico_arrow_down.svg';
import cartIcon from './ico_cart.svg';
import cartWhiteIcon from './ico_cart_white.svg';
import closeIcon from './ico-close.svg';
import closeIconNew from './ico-new-close.svg';
import creditCard from './credit-card.svg';
import eyeIcon from './ico_eye.svg';
import eyeClosedIcon from './ico_eye_closed.svg';
import visa from './visa.svg';
import playIcon from './ico-play.svg';
import playIconDark from './ico-play-dark.svg';
import playIconEpgHovered from './ico-play-epg-hovered.svg';
import playOutlineIcon from './ico-play-outline.svg';
import searchIcon from './ico-search.svg';
import googlepay from './googlepay.svg';
import dropdownIcon from './ico-arrow-down.svg';
import timeIndicatorIcon from './time-indicator.svg';
import tvPlaceholderIcon from './ico-tv-placeholder.svg';
import mailIcon from './ico-mail.svg';
import epgScrubber from './epg-slider.svg';
import pauseIconSimple from './ico_pause.svg';
import playIconSimple from './ico_play.svg';
import iconJumpBackwardStrong from './ico_skip_backward_strong.svg';
import iconJumpForwardStrong from './ico_skip_forward_strong.svg';
import volumeIcon from './ico_audio.svg';
import volumeMinIcon from './ico_audio_min.svg';
import volumeMutedIcon from './ico_audio_muted.svg';
import nextAssetIcon from './ico_next.svg';
import infoIcon from './ico_info.svg';
import castIcon from './ico_cast.svg';
import castConnectedIcon from './ico-cast-connected.svg';
import fullScreenIcon from './ico-full-screen.svg';
import shrinkScreenIcon from './ico-full-screen-reverse.svg';
import ico_home from './ico_home.svg';
import ico_tv from './ico_tv.svg';
import ico_on_demand from './ico_on_demand.svg';
import ico_movies from './ico_movies.svg';
import ico_kids from './ico_kids.svg';
import userIcon from './ico_user.svg';
import avatarIcon from './avatar_icon.svg';
import applepay from './applepay.svg';
import imdbIcon from './ico-imdb.svg';
import showMoreIcon from './ico_show_more.svg';
import catchUpIcon from './ico_catchup.svg';
import lockIcon from './ico_lock.svg';
import unlockIcon from './ico-unlock.svg';
import starIcon from './ico_star.svg';
import heartIcon from './ico_heart.svg';
import checkMarkIcon from './ico_checkmark.svg';
import emptyHeartIcon from './ico_heart_empty.svg';
import icon404 from './404-icon.svg';
import icoOngoingRecording from './ico_rec_ongoing.svg';
import icoScheduledRecording from './ico_rec_scheduled.svg';
import icoRecordedRecording from './ico_rec_recorded.svg';
import icoRecord from './ico_record.svg';
import icoEndRecording from './ico_end_recording.svg';
import icoDeleteRecording from './ico_delete_recording.svg';
import icoDoneRecording from './ico_record_done.svg';
import icoGoToLiveProgram from './live_icon.svg';
import icoSettings from './ico_settings.svg';
import icoDeviceDesktop from './ico-device-desktop.svg';
import icoDevicePhone from './ico-device-phone.svg';
import icoDeviceTablet from './ico-device-tablet.svg';
import icoDeviceTv from './ico-device-tv.svg';
import icoDeviceStb from './ico-device-stb.svg';
import icoSettingsPlaceholder from './ico-settings-placeholder.svg';
import icoTrash from './ico_trash.svg';
import icoLanguage from './ico_language.svg';
import EnFlag from './ico_enFlag.svg';
import EtFlag from './ico_etFlag.svg';
import RuFlag from './ico_ruFlag.svg';
import icoSearchHistory from './ico-search-history.svg';
import icoFavoriteEmpty from './ico-favorite-empty.svg';
import icoFavorite from './ico-favorite.svg';
import icoMinimize from './ico-minimize.svg';
import icoPlayIconHovered from './ico-playIcon-hovered.svg';
import icoFilter from './ico_filter.svg';
import icoGalleryPlay from './ico-new-gallery-play.svg';
import icoGalleryPause from './ico-new-gallery-pause.svg';
import icoGalleryLeft from './ico-new-gallery-left.svg';
import icoGalleryRight from './ico-new-gallery-right.svg';
import externalLink from './external-link.svg';
import accessibility from './ico-accessibility.svg';
import moreEpisodes from './ico-show-more-series.svg';
import chevronDown from './ico-new-chevron-down.svg';
import icoCalendar from './ico-new-calendar.svg';
import icoChannels from './ico-new-channels.svg';
import toastSuccess from './toast_success.svg';
import toastError from './ico-toast-error.svg';
import epgRecording from './ico-epg-recording.svg';
import epgRecordingDone from './ico-epg-recording-done.svg';
import epgRecordingFuture from './ico-epg-recording-future.svg';
import epgRecordingHover from './ico-epg-recording-hover.svg';
import epgRecordingDoneHover from './ico-epg-recording-done-hover.svg';
import epgRecordingFutureHover from './ico-epg-recording-future-hover.svg';
import toastRecordingStart from './ico-toast-recording-start.svg';
import toastRecordingStop from './ico-toast-recording-stop.svg';
import toastRecordingDelete from './ico-toast-recording-delete.svg';
import mastercard from './mastercard.svg';

export default {
    accountIcon,
    applepay,
    disclosureArrowIcon,
    leftArrowIcon,
    rightArrowIcon,
    rightArrowIconSmall,
    bottomArrowSmallIcon,
    downArrowIcon,
    cartIcon,
    cartWhiteIcon,
    creditCard,
    closeIcon,
    closeIconNew,
    eyeIcon,
    eyeClosedIcon,
    playIcon,
    playIconDark,
    playIconEpgHovered,
    playOutlineIcon,
    searchIcon,
    dropdownIcon,
    timeIndicatorIcon,
    tvPlaceholderIcon,
    epgScrubber,
    mailIcon,
    playIconSimple,
    iconJumpForwardStrong,
    iconJumpBackwardStrong,
    nextAssetIcon,
    infoIcon,
    castIcon,
    castConnectedIcon,
    pauseIconSimple,
    volumeIcon,
    volumeMinIcon,
    volumeMutedIcon,
    fullScreenIcon,
    shrinkScreenIcon,
    userIcon,
    avatarIcon,
    imdbIcon,
    showMoreIcon,
    ico_home,
    ico_tv,
    ico_on_demand,
    ico_movies,
    ico_kids,
    catchUpIcon,
    lockIcon,
    unlockIcon,
    starIcon,
    heartIcon,
    checkMarkIcon,
    emptyHeartIcon,
    icon404,
    icoOngoingRecording,
    icoScheduledRecording,
    icoRecordedRecording,
    icoRecord,
    icoEndRecording,
    icoDeleteRecording,
    icoDoneRecording,
    icoGoToLiveProgram,
    icoSettings,
    icoDeviceDesktop,
    icoDevicePhone,
    icoDeviceTablet,
    icoDeviceTv,
    icoDeviceStb,
    icoTrash,
    icoLanguage,
    EnFlag,
    EtFlag,
    RuFlag,
    icoSearchHistory,
    icoFavoriteEmpty,
    icoFavorite,
    icoMinimize,
    icoPlayIconHovered,
    icoSettingsPlaceholder,
    icoFilter,
    icoGalleryPlay,
    icoGalleryPause,
    icoGalleryLeft,
    icoGalleryRight,
    externalLink,
    accessibility,
    moreEpisodes,
    chevronDown,
    icoCalendar,
    icoChannels,
    toastSuccess,
    toastError,
    epgRecording,
    epgRecordingDone,
    epgRecordingFuture,
    epgRecordingHover,
    epgRecordingDoneHover,
    epgRecordingFutureHover,
    toastRecordingStart,
    toastRecordingStop,
    toastRecordingDelete,
    googlepay,
    mastercard,
    visa,
};
